export default "__VITE_ASSET__4678ec51__"